<template>
   <div id="addBrand">
     <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
             <loading :active.sync="isLoading" 
                :can-cancel="true" 
                :is-full-page="fullPage"></loading>
          
            <h5 class="modal-title" id="exampleModalLabel">Add Brand</h5>
            <button type="button" class="close"  @click="$emit('close')"  aria-label="Close">
              <i class="material-icons">close</i>
            </button>
          </div>
          <form @keyup.enter="addBrand()">
             <p style="color:red;text-align:center">{{ errorMessage }}</p>
             <p v-if="errors.length">
                <!-- <ul>
                  <li style='color:red' v-for="error in errors">{{ error }}</li>
                </ul> -->
                <p style='color:red;text-align:center' v-for="error in errors"> {{ error }}</p>
              </p>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-6">
                  <h6 class="sub-title">Brand Information</h6>
                  <div class="form-group">
                    <input type="text" class="form-control" ref="brandname" name="brandname" v-model="input.brandname" placeholder="Brand Name*" />
                  </div>
                  <div class="form-group">
                    <input type="text" class="form-control" ref="siteurl" name="siteurl" v-model="input.siteurl" placeholder="Site URL*" />
                  </div>

                  <div class="form-group">
                    <input type="email" class="form-control"  ref="email" name="email" v-model="input.email" placeholder="Email*" />
                  <p class="sub-title" style="color:blue;">This is where the invoice will be sent.</p>
                  </div>

                  <div class="form-group">
                    <input type="text" class="form-control" ref="address" name="address" v-model="input.address"  placeholder="Complete Address*" />
                  </div>
                  <div class="form-group">
                    <input type="text" class="form-control" ref="contactno" name="contactno" v-model="input.contactno" placeholder="Contact Number*" />
                  </div>
                  <div class="form-group">
                    <input class="form-control" type="file"  name="brand_logo" ref="fileaddBrand" id="fileaddBrand" v-on:change="handleFileUpload()" />
                  </div>
                </div>
                <div class="col-md-6">
                  <h6 class="sub-title">Contact Information</h6>
                  <div class="form-group">
                   <!--  <input type="text" class="form-control" ref="contacttitle" name="contacttitle" v-model="input.contacttitle" placeholder="Contact Title*" /> -->
                  </div>
                  <div class="form-group d-flex">
                    <select class="form-control select" ref="nameprefix" id="nameprefix" name="nameprefix" v-model="input.nameprefix" @change="changePrefix($event)">
                      <option value="" selected>Select Title</option>
                      <option value="Mr" selected>Mr </option>
                      <option value="Mrs">Mrs </option>
                      <option value="Ms">Ms </option>
                    </select>
                    <input type="text" class="form-control" ref="contactfirstname" name="contactfirstname" v-model="input.contactfirstname" placeholder="Contact First Name*" />
                  </div>
                  <div class="form-group">
                    <input type="text" class="form-control" ref="contactlastname" name="contactlastname" v-model="input.contactlastname" placeholder="Contact Last Name*" />
                  </div>
                  <div class="form-group">
                    <input type="text" class="form-control" ref="contactemail" name="contactemail" v-model="input.contactemail" placeholder="Contact Email*" />
                  </div>
                </div>
              </div>
            </div>
           <div class="modal-footer">
              <input type="button" class="btn btn-primary" value="Add" v-on:click="addBrand()"/>
              <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="$emit('close')">Cancel</button>
            </div>
          </form>
        </div>
      </div>
    </div>
</template>
<script>
  import axios from 'axios'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  require('vue-flash-message/dist/vue-flash-message.min.css')
  export default {
    name: 'Brands',
    components: {
      Loading
    },
    data () {
      return {
        checkExt: false,
        isLoading: false,
        errorMessage: '',
        fullPage: true,
        brands: [],
        errors: [],
        input: {
          email: '',
          brandname: '',
          siteurl: '',
          contactno: '',
          address: '',
          contacttitle: '',
          contactfirstname: '',
          contactlastname: '',
          contactemail: '',
          brand_logo: '',
          nameprefix: ''
        }
    }
   },
    methods: {
      addBrand () {
        var jwttoken = localStorage.getItem('jwt')
        var fuData = document.getElementById('fileaddBrand')
        //alert(fuData)
        var contactNo = this.input.contactno
        var FileUploadPath = fuData.value
        console.log(FileUploadPath)
        var ext = FileUploadPath.substring(FileUploadPath.lastIndexOf('.') + 1).toLowerCase()
        //console.log(ext)
        this.errors = []
        if (this.input.brandname === '') {
          this.errors.push('Brand Name is Required')
          this.$refs.brandname.focus()
        } else if (this.input.siteurl === '') {
          this.errors.push('Siteurl is Required')
          this.$refs.siteurl.focus()
        } else if (!this.validUrl.isUri(this.input.siteurl)){  
            this.errors.push('Not a URL')
            this.$refs.siteurl.focus()
       }
          else if (this.input.email === '') {   
          this.errors.push('Email is Required')
          this.$refs.email.focus()
        } else if (!this.emailValidator.validate(this.input.email)) {
          this.errors.push('Invalid Email')
          this.$refs.email.focus()
        } else if (this.input.address === '') {
          this.errors.push('Address is Required')
          this.$refs.address.focus()
        } else if (contactNo === '') {
          this.errors.push('Contactno is Required')
          this.$refs.contactNo.focus()
        } else if (isNaN(contactNo) || contactNo.indexOf(" ")!=-1) {
          this.errors.push('Enter numeric value')
          this.$refs.contactNo.focus()
        } else if (contactNo.length !== 10) {
          this.errors.push('Enter 10 Numbers Only')
          this.$refs.contactNo.focus()
        } else if (this.fileaddBrand === '') {
          this.errors.push('File is Required')
          this.$refs.fileaddBrand.focus()
        } else if (!this.checkExtension(ext)) {
          this.errors.push('Only jpeg , png , gif Allowed')
        } else if (this.input.nameprefix === '') {
          this.errors.push('Name prfix is Required')
          this.$refs.nameprefix.focus()
        } else if (this.input.contactfirstname === '') {
          this.errors.push('Contact First name is Required')
          this.$refs.contactfirstname.focus()
        } else if (this.input.contactlastname === '') {
          this.errors.push('Contact Last name is Required')
          this.$refs.contactlastname.focus()
        } else if (this.input.contactemail === '') {
          this.errors.push('Contact Email is Required')
          this.$refs.contactemail.focus()
        }else if (!this.emailValidator.validate(this.input.contactemail)) {
          this.errors.push('Invalid contact Email')
          this.$refs.contactemail.focus()
        }  else {
          this.isLoading = true
          let formData = new FormData()
          formData.append('email', this.input.email)
          formData.append('brand_name', this.input.brandname)
          formData.append('site_url', this.input.siteurl)
          formData.append('contact_no', this.input.contactno)
          formData.append('address', this.input.address)
          formData.append('brand_logo', this.fileaddBrand)
          formData.append('contact_title', this.input.contacttitle)
          formData.append('contact_name_prefix', this.input.nameprefix)
          formData.append('contact_first_name', this.input.contactfirstname)
          formData.append('contact_last_name', this.input.contactlastname)
          formData.append('contact_email', this.input.contactemail)
          axios.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/createNewBrand',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                'x-access-token': jwttoken
              }
            }
          ).then(response => {
            this.isLoading = false
            this.$eventBus.$emit('listBrand', 'Brand is Added successfully');
            this.$emit('close')
           })
            .catch((error) => {
              this.$eventBus.$emit('listBrand', '','Brand could not be Added');
              this.$emit('close')
              this.errorMessage = error.response.data.errors
              this.isLoading = false
            })
        }
      },
      handleFileUpload () {
        this.fileaddBrand = this.$refs.fileaddBrand.files[0]
      }
    }

}
</script>



// WEBPACK FOOTER //
// src/components/AddBrand.vue